import { getLanguage } from '@/common/utils/i18n'

function getMapUrl () {
  let url = 'https://lbsapi.mykeeta.com/jsapi/tmap-i18n'
  try {
    // @ts-ignore
    url = process_env_aMapCDN
  } catch (error) {
    console.log(error)
  }
  return url
}
const MAP_VERSION = '2.8.0-alpha.0' // 2.2.0

/** 加载地图 */
export const loadMapScript = (callback?: () => void) => {
  if (window.AMap) { // 有实例,直接执行cb
    if (callback) callback()
    return
  }
  const lang = getLanguage()
  const scriptId = 'mapScript'

  // 检查脚本是否已经存在
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script')
    script.id = scriptId
    script.crossOrigin = 'anonymous'
    script.type = 'text/javascript'
    // eslint-disable-next-line max-len
    script.src = `${getMapUrl()}?key=m40f92525d894c91923d73627821cd1j&v=${MAP_VERSION}&tmap_env=overseas&overseas_type=google&errorSwitch=open&google_key=AIzaSyDHqdTeZFNzuYadq6w7tgg8-3GXTNFW_qM&callback=mapInit&language=${lang}`

    // 脚本加载完成后执行回调函数
    script.onload = () => {
      console.log('地图sdk加载,等待执行') // 加载完成,不代表执行完成
    }
    document.head.appendChild(script)
  }

  let mapInterval = null
  console.log('开始轮询地图初始化状态')
  mapInterval = setInterval(() => { // 轮询是否已成功挂载地图.(有可能是其他地方引用了地图挂载)
    if (window.AMap) {
      clearInterval(mapInterval)  // 清除轮询
      console.log('地图初始化完成,结束轮询')
      if (callback) callback()
    }
  }, 100)
}

